__turbopack_context__.v({
  "animatedWrapper": "AH2IEW_animatedWrapper",
  "container": "AH2IEW_container",
  "listItem": "AH2IEW_listItem",
  "loaderWrapper": "AH2IEW_loaderWrapper",
  "productGrid": "AH2IEW_productGrid",
  "wiggle": "AH2IEW_wiggle",
});
